/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Detail_DepositInputs */

const en_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposit at least $300.`)
};

const de_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlen Sie mindestens 300 $ ein.`)
};

const pt_br2_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposite pelo menos US$ 300.`)
};

const tr_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En az $300 yatırın.`)
};

const zh_cn2_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存入至少 300 美元。`)
};

const zh_hk2_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`存入至少 $300。`)
};

const ko_kr2_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최소 $300를 입금하세요.`)
};

const ru_ru2_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внесите не менее $300.`)
};

const es_419_campaigns_mag7_detail_deposit = /** @type {(inputs: Campaigns_Mag7_Detail_DepositInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposita al menos $300.`)
};

/**
* | output |
* | --- |
* | "Deposit at least $300." |
*
* @param {Campaigns_Mag7_Detail_DepositInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_detail_deposit = /** @type {((inputs?: Campaigns_Mag7_Detail_DepositInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Detail_DepositInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_detail_deposit(inputs)
	if (locale === "de") return de_campaigns_mag7_detail_deposit(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_detail_deposit(inputs)
	if (locale === "tr") return tr_campaigns_mag7_detail_deposit(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_detail_deposit(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_detail_deposit(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_detail_deposit(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_detail_deposit(inputs)
	return es_419_campaigns_mag7_detail_deposit(inputs)
});